import React from 'react';

export type SeparatorOrientation = 'horizontal' | 'vertical';

export interface ISeparatorProps {
  className?: string;
  label?: string;
  orientation?: SeparatorOrientation;
  size?: string;
}

export const Separator = ({
  className,
  label,
  orientation = 'horizontal',
  size = 'sm'
}: ISeparatorProps) => {
  const title = label ? label : 'or';

  let classname = `mdf-separator-horizontal-${size}`;

  if (orientation === 'vertical') {
    classname = `mdf-separator-vertical-${size}`;
  }

  if (className) {
    classname += ' ' + className;
  }

  return (
    <div className={classname}>
      <div></div>
      <div>{title}</div>
      <div></div>
    </div>
  );
};

Separator.displayName = 'Separator';
